<template>
  <div class="vh-full vh-flex">
    <!--一级分类-->
    <div class="vrgc1">
      <div @click="RootGroupClick(item)" v-for="item in listGroup1" :key="item.id"
        :class="{ 'gpsel': item.id == selectGroup1 }" class="gp-item focus-s">{{
          item.name }}</div>
    </div>
    <!--二级分类-->
    <div v-if="listGroup2.length > 0">
      <div class="vrgc2">
        <div @click="secondGroupClick(item)" v-for="item in listGroup2" :key="item.id"
          :class="{ 'gssel': item.id == selectGroup2 }" class="gs-item focus-s">{{
            item.name }}</div>
      </div>
    </div>
    <!--三级分类-->
    <div class="vrgc2" v-if="listGroup3.length > 0">
      <div @click="thirdGroupClick(item)" v-for="item in listGroup3" :key="item.id"
        :class="{ 'gdsel': item.id == selectGroup3 }" class="gd-item focus-s">{{
          item.name }}</div>
    </div>
    <!--空白视图-->
    <EmptyView v-if="listResource.length == 0" class="vh-full"></EmptyView>
    <!--资源视图-->
    <el-scrollbar v-else class="vh-full" v-loading="showLoading">
      <div class="inrect">
        <div @click="downloadResource(item)" v-for="item in listResource" :key="item" class="res-item">
          <div class="vh-full ctxd"
            :style="{ 'background-image': item.resImage != '' ? 'url(' + item.resImage + ')' : 'var(--ek-card-color2)' }">
            <SvgIcon svgname="ic_readbook" fill="#FFFFFF" :size="70" style="opacity: 0.6;"></SvgIcon>
          </div>
          <div class="resname">{{ item.name }}</div>
        </div>
      </div>
    </el-scrollbar>
    <div class="vpage">
      <el-pagination layout="prev, pager, next,total,jumper" :total="page.totalCount" :page-size="page.size"
        @current-change="onPageChange" />
    </div>

    <!--下载对话框-->
    <DownloadResourceDialog :show="downDialog.show" :resInfo="downDialog.resInfo" @selectButton="downDialog.callBack">
    </DownloadResourceDialog>
  </div>
</template>

<script>
import httpClient from '@/commom/http/httpClient';
import EmptyView from '@/components/EmptyView.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import DownloadResourceDialog from './dialog/DownloadResourceDialog.vue';
import eventBus from '@/commom/event/EventBus';
export default {
  name: 'OnlineStore',
  components: {
    EmptyView,
    SvgIcon,
    DownloadResourceDialog
  },
  props: {

  },
  data() {
    return {
      showLoading: false,
      ///选择的一级分类
      selectGroup1: "1",
      selectGroup2: "1",
      selectGroup3: "1",
      listGroup1: [],
      listGroup2: [],
      listGroup3: [],
      listAllGroup: [],
      listResource: [],
      page: {
        index: 1,
        size: 30,
        totalCount: 0,
      },
      downDialog: {
        show: false,
        resInfo: null,
        callBack: null
      }
    }
  },
  mounted: function () {
    this.loadGroupData()
  },
  methods: {
    ///加载数据
    loadGroupData: function () {
      this.showLoading = true
      var that = this
      var req = {
        groupType: "book"
      }
      httpClient.invoke("ResourceGroupAPI.GetGroupList", req, function (res) {
        that.showLoading = false
        if (res.error) {
          that.$message.error(res.error)
          return
        }
        that.listAllGroup = res
        //加载一级分类
        that.listGroup1 = res.filter(item => item.pid == "root")

        that.RootGroupClick(that.listGroup1[0])
      })
    },
    ///加载数据
    loadResource: function () {

      var that = this
      var groupId = this.selectGroup3
      if (groupId == "") {
        groupId = this.selectGroup2
      }
      if (groupId == "") {
        groupId = this.selectGroup1
      }
      if (groupId == "") {
        that.$message.error("未知错误!")
        return
      }

      var req = {
        page: that.page.index,
        size: that.page.size,
        groupId: groupId,
        keyword: ""
      }
      this.showLoading = true
      httpClient.invoke("ResourceInfoAPI.GetResourcePage", req, function (res) {
        that.showLoading = false
        if (res.error) {
          that.$message.error(res.error)
          return
        }
        if (req.page == 1) {
          that.page.totalCount = res.totalCount
        }
        that.listResource = res.listItem
      })
    },
    ///加载第一页数据
    loadFirstResourcePage: function () {
      this.page.index = 1
      this.loadResource()
    },
    ///一级分类点击
    RootGroupClick: function (group) {
      this.selectGroup1 = group.id
      //加载二级分类
      this.listGroup2 = this.listAllGroup.filter(item => item.pid == group.id)
      if (this.listGroup2.length > 0) {
        //如果存在二级分类
        this.secondGroupClick(this.listGroup2[0])
        return
      }
      this.selectGroup2 = "";
      this.selectGroup3 = "";
      this.listGroup3 = []
      this.loadFirstResourcePage()
    },
    ///二级分类点击
    secondGroupClick: function (group) {
      this.selectGroup2 = group.id
      //加载三级分类
      this.listGroup3 = this.listAllGroup.filter(item => item.pid == group.id)
      if (this.listGroup3.length > 0) {
        ///如果存在三级分类
        this.thirdGroupClick(this.listGroup3[0])
        return
      }
      this.selectGroup3 = "";
      this.listGroup3 = []
      this.loadFirstResourcePage()
    },
    ///三级分类点击
    thirdGroupClick: function (group) {
      this.selectGroup3 = group.id
      this.loadFirstResourcePage()
    },
    ///下载资源
    downloadResource: function (item) {
      this.downDialog.resInfo = item
      this.downDialog.show = true
      var that = this
      this.downDialog.callBack = function (res) {
        that.downDialog.show = false
        if (!res) {
          return
        }
        eventBus.emit("mainPageEvent", { name: "gotoBookList" })

      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ctxd {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: transform 0.3s ease;
  background-size: cover;
}

.res-item:hover .ctxd {
  transform: scale(1.1);
}

.resname {
  background: #000000a8;
  line-height: 35px;
  padding-left: 15px;
  padding-right: 15px;
  color: white;
  font-size: 14px;
  position: absolute;
  bottom: 0px;
  width: 100%;
}

.inrect {
  padding-left: 20px;
  padding-right: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

/* 横屏平板 */
@media (min-width: 900px) and (max-width: 1200px) and (orientation: landscape) {
  .inrect {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

}

.res-item {
  display: inline-flex;

  height: 200px;
  background: var(--ek-card-color2);

  border-radius: 10px;
  flex-direction: column;
  overflow: clip;
  position: relative;
  cursor: pointer;
  box-shadow: 5px 5px 5px #0000004a;
}

.vpage {
  padding-left: 15px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-top: 15px;
}

.vrgc1 {
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  align-items: center;
}

.vrgc2 {
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  align-items: center;
  white-space: nowrap;
  overflow-x: auto;
}


.gp-item {
  font-size: 14px;
  background: var(--ek-card-color2);
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-right: 10px;
  color: var(--ek-text-color2);
  border-radius: 8px;
}

.gpsel {
  background-color: var(--ek-color-primary);
  color: white !important;
}

.gs-item {
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-top: 5px;
  color: var(--ek-text-color2);
}

.gssel {
  color: var(--ek-color-primary);
  border-bottom: 3px solid var(--ek-color-primary);
  background: var(--ek-card-color2);
}

.gd-item {
  font-size: 14px;
  padding-left: 10px;
  padding-right: 10px;
  color: var(--ek-text-color2);
}

.gdsel {
  color: var(--ek-text-color1);
  font-weight: bold;

}
</style>
